const fsErrors = {
  fileInvalidType: 'Формат файла не поддерживается',
  fileTooLarge: 'Файл больше чем',
  fileTooSmall: 'Файл меньше чем',
  tooManyFiles: 'Слишком много загружаемых файлов. Максимальное число:',
};

const networkErrors = {
  unauthorizedError: 'Ошибка авторизации',
  serverError: 'Сервер недоступен',
  unrecoverableErrorOccured: 'Извините, произошла неисправимая ошибка.',
  fetchTimeoutError:
    'Время выполнения запроса истекло. Попробуйте обновить страницу и повторить действие.',
  fetchError: 'Извините, при запросе данных произошел сбой.',
  tryToReloadPage:
    'Пожалуйста, попробуйте перезагрузить страницу, возможно, это был временный сбой.',
  reload: 'Перезагрузить страницу',
  serverDown: 'Что-то пошло не так. Повторите попытку позже.',
  networkError: 'При загрузке данных произошла ошибка. Проверьте Ваше подключение к сети.',
};

const validationMessages = {
  requiredField: 'Это поле обязательно для заполнения',
  pleaseSpecify: 'Пожалуйста, укажите',
  requiredAtLeastOneAssignee: 'Пожалуйста, укажите хотя бы одного исполнителя',
  requiredAtLeastOnePhone: 'Пожалуйста, укажите хотя бы один номер телефона',
  requiredCustomer: `Пожалуйста, укажите клиента`,
  requiredLastName: `Пожалуйста, укажите фамилию`,
  maxLengthMessage: 'Длина сообщения не должна превышать 220 символов',
  maxLengthComment: 'Длина комментария должна быть не менее 14 символов',
  wrongPhoneFormat: 'Вы указали неверный формат номера телефона',
  passwordCyrillic: 'В пароле запрещена кириллица',
  wrongEmailFormat: 'Вы указали неверный формат электронной почты',
  requiredPassportSeries: 'Пожалуйста, укажите серию и номер паспорта',
  wrongPassportSeries: 'Вы указали неверный формат серии и номера паспорта',
  requiredPassportDate: 'Пожалуйста, укажите дату выдачи паспорта',
  requiredBirthday: 'Пожалуйста, укажите день рождения',
  wrongPassportDate: 'Вы указали неверный формат даты выдачи паспорта',
  wrongPassportCode: 'Вы указали неверный формат кода поздразделения',
  requiredAtLeastOneRole: 'Пожалуйста, укажите хотя бы одну роль',
  requiredAtLeastCustomerConstruction: 'Пожалуйста, заполните одно из полей: Клиент или Объект',
  longDistance: 'Вы слишком далеко от объекта',
  wrongUserCoordinates: 'Не можем определить Вашу геолокацию',
  requiredThreeCharacters: 'Для поиска по названию или ФИО нужно ввести не менее трех символов',
  requiredDateStart: 'Пожалуйста, укажите дату начала этапа',
  requiredManagerName: 'Пожалуйста, укажите ФИО руководителя',
  floorCountMustBeInteger: 'Этажность должна быть целым числом',
  requiredPeriod: 'Пожалуйста, укажате период',
  minValue: 'Минимальное значение',
  maxValue: 'Максимальное значение',
};

const positionErrors = {
  geolocationNotSupported: 'Геолокация не поддерживается в вашем браузере',
  permissionDenied: 'Для полноценной работы с картами, включите геолокацию на устройстве',
  positionUnavailable: 'Не удалось связаться со службой определения местоположения',
  positionTimeout: 'Не удалось определить местоположение в течении установленного времени',
};

export default {
  ...fsErrors,
  ...networkErrors,
  ...validationMessages,
  ...positionErrors,
  notFound: 'Ничего не найдено',
  noMatches: 'Совпадений нет',
  noResults: 'Результаты не найдены',
  tryChangeSearchParams: 'Попробуйте изменить параметры поиска',
  tryStartTypingText: 'Для поиска результатов, начните вводить текст',
  noCheckinObjects: "Отсутствуют объекты, доступные для чекина",
  noMeetingTasks: "Отсутствуют задачи, доступные для чекина",
  notFoundPage: 'Страница не найдена',
  errorCopyToClipboard: 'Ошибка при копировании в буфер обмена',
};
